import { render, staticRenderFns } from "./JobAccountAltShipQuestions.vue?vue&type=template&id=35585fcc&scoped=true"
import script from "./JobAccountAltShipQuestions.vue?vue&type=script&lang=js"
export * from "./JobAccountAltShipQuestions.vue?vue&type=script&lang=js"
import style0 from "./JobAccountAltShipQuestions.vue?vue&type=style&index=0&id=35585fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35585fcc",
  null
  
)

export default component.exports